import React, { useEffect, useState } from 'react'
import { Container, Row, Col, OverlayTrigger, Tooltip, Form, Button, Modal } from 'react-bootstrap'
import Card from '../../../components/Card'
import ServicesRequest from '../../../service/ServiceRequest'
import { Link, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'
import SearchComponent from '../../../components/partials/backend/Search/SearchComponent'
import SortToggle from '../../../components/partials/backend/SortToggle/SortToggle'
import PaginationComponent from '../../../components/partials/backend/Pagination/PaginationComponent'
import BootstrapSwitchButton from "bootstrap-switch-button-react"

const opportunityStatesMap = {
  "NA": "NA",
  "1": "Nuova opportunità",
  "2A": "Richiesta documenti cliente",
  "2B": "Richiesta Quota B.O. Istituto",
  "3A": "Documenti Rientrati",
  "3B": "Quota Rientrata",
  "4A": "Preventivo accettato",
  "4B": "Preventivo non Accettato",
  "4C": "Cliente Ci Pensa",
  "5": "Controllo Qualità B.O. Interno",
  "6A": "In attesa di integrazione documenti",
  "6B": "Assegnato B.O. Istituto",
  "7": "Documenti Rientrati",
  "8A": "In attesa di CDS",
  "8B": "In attesa di cedolino pensione",
  "9": "Caricata Banca",
  "10": "Contratto firmato",
  "11": "Contratto Notificato",
  "12": "Contratto liquidato",
  "13": "Annullato",
  "14": "Mai Fattibile",
  "15": "Maturazione TFR"
}

const Contact = () => {
  const location = useLocation()
  const initialState = location.state || {}
  const service = new ServicesRequest("people/contact")
  const [contacts, setContacts] = useState([])
  const [paginationObject, setPaginationObject] = useState(null)
  const [users, setUsers] = useState([])
  const [agencies, setAgencies] = useState([])
  const { config } = useSelector((state) => state.auth)
  const [loading, setLoading] = useState(false)
  const [search, setSearch] = useState(initialState.search || "")
  const [sort, setSort] = useState(initialState.sort || "")
  const [filter, setFilter] = useState(initialState.filter || "")
  const [contactStatusFilter, setContactStatusFilter] = useState(initialState.contactStatusFilter || "")
  const [assignedUserFilter, setAssignedUserFilter] = useState(initialState.assignedUserFilter || "")
  const [assignedAgencyFilter, setAssignedAgencyFilter] = useState(initialState.assignedAgencyFilter || "")
  const [categoriaDiLavoroFilter, setCategoriaDiLavoroFilter] = useState(initialState.categoriaDiLavoroFilter || "")
  const [createdByFilter, setCreatedByFilter] = useState(initialState.createdByFilter || "")
  const [createdAtFrom, setCreatedAtFrom] = useState(initialState.createdAtFrom || "")
  const [createdAtTo, setCreatedAtTo] = useState(initialState.createdAtTo || "")
  const [dataPerRichiamareFrom, setDataPerRichiamareFrom] = useState(initialState.dataPerRichiamareFrom || "")
  const [dataPerRichiamareTo, setDataPerRichiamareTo] = useState(initialState.dataPerRichiamareTo || "")
  const [opportunityStateFilter, setOpportunityStateFilter] = useState(initialState.opportunityStateFilter || "")
  const [hasMaturingTrattenutaFilter, setHasMaturingTrattenutaFilter] = useState(initialState.hasMaturingTrattenutaFilter || "")
  const [nPages, setPage] = useState(0)
  const [page, setCurrentPage] = useState(initialState.page || 1)
  const [numberOfItem, setNumberOfItem] = useState(0)
  const [selectedContacts, setSelectedContacts] = useState([])
  const [showBulkAssignModal, setShowBulkAssignModal] = useState(false)
  const [assignmentType, setAssignmentType] = useState('') // 'user' or 'agency'
  const [selectedUserId, setSelectedUserId] = useState('')
  const [selectedAgencyId, setSelectedAgencyId] = useState('')
  const [showIndividualAssignModal, setShowIndividualAssignModal] = useState(false)
  const [currentContact, setCurrentContact] = useState(null)
  const [individualAssignmentType, setIndividualAssignmentType] = useState('')
  const [individualSelectedUserId, setIndividualSelectedUserId] = useState('')
  const [individualSelectedAgencyId, setIndividualSelectedAgencyId] = useState('')

  async function fetchList(url = null) {
    setLoading(true)
    // Combine filters
    let combinedFilter = filter
    if (assignedUserFilter) {
      combinedFilter = combinedFilter ? `${combinedFilter}&${assignedUserFilter}` : assignedUserFilter
    }
    if (contactStatusFilter) {
      combinedFilter = combinedFilter ? `${combinedFilter}&${contactStatusFilter}` : contactStatusFilter
    }
    if (assignedAgencyFilter) {
      combinedFilter = combinedFilter ? `${combinedFilter}&${assignedAgencyFilter}` : assignedAgencyFilter
    }
    if (categoriaDiLavoroFilter) {
      combinedFilter = combinedFilter ? `${combinedFilter}&${categoriaDiLavoroFilter}` : categoriaDiLavoroFilter
    }
    if (createdByFilter) {
      combinedFilter = combinedFilter ? `${combinedFilter}&${createdByFilter}` : createdByFilter
    }
    if (createdAtFrom) {
      combinedFilter = combinedFilter ? `${combinedFilter}&filter_from_created_at=${createdAtFrom}` : `filter_from_created_at=${createdAtFrom}`
    }
    if (createdAtTo) {
      combinedFilter = combinedFilter ? `${combinedFilter}&filter_to_created_at=${createdAtTo}` : `filter_to_created_at=${createdAtTo}`
    }
    if (dataPerRichiamareFrom) {
      combinedFilter = combinedFilter ? `${combinedFilter}&filter_from_data_per_richiamare=${dataPerRichiamareFrom}` : `filter_from_data_per_richiamare=${dataPerRichiamareFrom}`
    }
    if (dataPerRichiamareTo) {
      combinedFilter = combinedFilter ? `${combinedFilter}&filter_to_data_per_richiamare=${dataPerRichiamareTo}` : `filter_to_data_per_richiamare=${dataPerRichiamareTo}`
    }
    if (opportunityStateFilter) {
      combinedFilter = combinedFilter ? `${combinedFilter}&${opportunityStateFilter}` : opportunityStateFilter
    }
    if (hasMaturingTrattenutaFilter) {
      combinedFilter = combinedFilter ? `${combinedFilter}&${hasMaturingTrattenutaFilter}` : hasMaturingTrattenutaFilter
    }
    
    // Pagination uses full URLs; filter/search reloads must always start at page 1
    // (stale page + narrower filter → empty list).
    const pageToFetch = url ? page : 1
    if (!url && page !== 1) {
      setCurrentPage(1)
    }
    const response = await service.getProductList(combinedFilter, sort, search, pageToFetch, url)
    if (!response.response) {
      setContacts(response.data || [])
      if(response.pagination){
        setPaginationObject(response.pagination)
        setPage(response.pagination.n_pages)
        setCurrentPage(response.pagination.current_page)
        setNumberOfItem(response.pagination.n_items)
      }
    } else {
      setContacts([])
    }
    setLoading(false)
  }

  // Fetch users for the assigned user filter
  async function fetchUsers() {
    const userService = new ServicesRequest("user")
    const response = await userService.getProductListComplete()
    if (!response.response) {
      // Backend already filters users based on user role and permissions
      // No need for additional frontend filtering
      setUsers(response.data || [])
    }
  }

  // Fetch agencies for the assigned agency filter
  async function fetchAgencies() {
    const agencyService = new ServicesRequest("agency")
    const response = await agencyService.getProductListComplete()
    if (!response.response) {
      setAgencies(response.data || [])
    }
  }

  // Handle contact selection
  function handleContactSelect(contactId, isSelected) {
    if (isSelected) {
      setSelectedContacts([...selectedContacts, contactId])
    } else {
      setSelectedContacts(selectedContacts.filter(id => id !== contactId))
    }
  }

  // Handle select all
  function handleSelectAll(isSelected) {
    if (isSelected) {
      setSelectedContacts(contacts.map(c => c.id))
    } else {
      setSelectedContacts([])
    }
  }

  // Bulk assign users or agencies
  async function handleBulkAssign(assignedUserId, assignedAgencyId) {
    if (selectedContacts.length === 0) {
      alert('Seleziona almeno un contatto')
      return
    }

    try {
      const result = await service.bulkAssignUser(
        selectedContacts,
        assignedUserId || null,
        assignedAgencyId || null
      )
      if (result.success) {
        alert(result.message)
        setSelectedContacts([])
        setShowBulkAssignModal(false)
        setAssignmentType('')
        setSelectedUserId('')
        setSelectedAgencyId('')
        fetchList() // Refresh the list
      } else {
        alert('Errore: ' + result.error)
      }
    } catch (error) {
      console.error('Error:', error)
      alert('Errore durante l\'assegnazione')
    }
  }

  async function handleIndividualAssign(contactId, assignedUserId, assignedAgencyId) {
    try {
      console.log("Assinging User")
      const result = await service.assignUser(
        contactId,
        assignedUserId || null,
        assignedAgencyId || null
      )
      if (result.id) {
        alert('Contatto assegnato con successo')
        setShowIndividualAssignModal(false)
        setCurrentContact(null)
        setIndividualAssignmentType('')
        setIndividualSelectedUserId('')
        setIndividualSelectedAgencyId('')
        fetchList() // Refresh the list
      } else {
        alert('Errore: ' + (result.error || 'Impossibile assegnare il contatto'))
      }
    } catch (error) {
      console.error('Error:', error)
      alert('Errore durante l\'assegnazione')
    }
  }

  useEffect(() => { 
    fetchList()
    if (config.is_admin || config.is_agency_boss || config.is_agency_admin || config.is_internal_backoffice_manager || config.is_institute_backoffice_manager){
      fetchUsers()
      fetchAgencies()
    }
  }, [search, sort, filter, contactStatusFilter, assignedUserFilter, assignedAgencyFilter, categoriaDiLavoroFilter, createdByFilter, createdAtFrom, createdAtTo, dataPerRichiamareFrom, dataPerRichiamareTo, opportunityStateFilter, hasMaturingTrattenutaFilter])

  return (
    <>
      <Container fluid>
        <Row>
          <Col lg="12">
            <div className="d-flex flex-wrap align-items-center justify-content-between my-schedule mb-4">
              <div className="d-flex align-items-center justify-content-between">
                <h4 className="font-weight-bold">Contatti</h4>
              </div>
              <div className="create-workform">
                <div className="d-flex flex-wrap align-items-center justify-content-between">
                  <div className="modal-product-search d-flex">
                    <div className="mr-3 position-relative">
                      <SearchComponent search={search} setSearch={setSearch} setCurrentPage={setCurrentPage}/>
                    </div>
                    {(config.is_admin || config.is_agency_boss) && selectedContacts.length > 0 && (
                      <Button 
                        variant="outline-success" 
                        size="sm"
                        onClick={() => setShowBulkAssignModal(true)}
                        className="d-flex align-items-center mr-3"
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" className="mr-2" width="16" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m13.5-9a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z" />
                        </svg>
                        Assegna ({selectedContacts.length})
                      </Button>
                    )}
                    {config.can_create && (config.is_admin || config.is_agency_boss || config.is_agent) && (
                        <Link to={{ pathname: "/contact-add", state: {
                          "filter" : filter, 
                          "sort" : sort, 
                          "search" : search, 
                          "page" : page,
                          "contactStatusFilter": contactStatusFilter,
                          "assignedUserFilter": assignedUserFilter,
                          "assignedAgencyFilter": assignedAgencyFilter,
                          "categoriaDiLavoroFilter": categoriaDiLavoroFilter,
                          "createdByFilter": createdByFilter,
                          "createdAtFrom": createdAtFrom,
                          "createdAtTo": createdAtTo,
                          "dataPerRichiamareFrom": dataPerRichiamareFrom,
                          "dataPerRichiamareTo": dataPerRichiamareTo,
                          "opportunityStateFilter": opportunityStateFilter,
                          "hasMaturingTrattenutaFilter": hasMaturingTrattenutaFilter
                        } }} className="btn btn-primary position-relative d-flex align-items-center justify-content-between">
                        <svg xmlns="http://www.w3.org/2000/svg" className="mr-2" width="20" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                        </svg>
                        Aggiungi Contatto
                      </Link>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* Filters Row */}
            <div className="d-flex flex-wrap align-items-center mb-3">
              <div className="mr-3">
                <Form.Control
                  as="select"
                  size="sm"
                  value={filter}
                  onChange={(e) => {
                    setCurrentPage(1);
                    setFilter(e.target.value);
                  }}
                  style={{ minWidth: '150px' }}
                >
                  <option value="">Contatta lo Stato di sospensione</option>
                  <option value="filter_is_suspended=false">Attivi</option>
                  <option value="filter_is_suspended=true">Sospesi</option>
                </Form.Control>
              </div>
              <div className="mr-3">
                <Form.Control
                  as="select"
                  size="sm"
                  value={contactStatusFilter}
                  onChange={(e) => {
                    setCurrentPage(1);
                    setContactStatusFilter(e.target.value);
                  }}
                  style={{ minWidth: '150px' }}
                >
                  <option value="">Tutti gli stati (Contatto)</option>
                  <option value="filter_contact_status=NA">NA</option>
                  <option value="filter_contact_status=Contatto Attivo">Contatto Attivo</option>
                  <option value="filter_contact_status=Contatto Non Interessato">Contatto Non Interessato</option>
                  <option value="filter_contact_status=Non Risponde">Non Risponde</option>
                  <option value="filter_contact_status=Richiamo Concordato">Richiamo Concordato</option>
                  <option value="filter_contact_status=Contatto Interessato">Contatto Interessato</option>
                  <option value="filter_contact_status=Mai Fattibile">Mai Fattibile</option>
                  <option value="filter_contact_status=Maturazione TFR">Maturazione TFR</option>
                </Form.Control>
              </div>
              <div className="mr-3">
                <Form.Control
                  as="select"
                  size="sm"
                  value={assignedUserFilter}
                  onChange={(e) => {
                    setCurrentPage(1);
                    setAssignedUserFilter(e.target.value);
                  }}
                  style={{ minWidth: '180px' }}
                >
                  <option value="">Tutti gli utenti</option>
                  <option value="filter_assigned_user=null">Non assegnati</option>
                  {users.map(user => (
                    <option key={user.email} value={`filter_assigned_user=${user.email}`}>
                      {user.name} {user.surname}
                    </option>
                  ))}
                </Form.Control>
              </div>
              <div className="mr-3">
                <Form.Control
                  as="select"
                  size="sm"
                  value={assignedAgencyFilter}
                  onChange={(e) => {
                    setCurrentPage(1);
                    setAssignedAgencyFilter(e.target.value);
                  }}
                  style={{ minWidth: '180px' }}
                >
                  <option value="">Tutte le agenzie</option>
                  <option value="filter_assigned_agency=null">Non assegnate</option>
                  {agencies.map(agency => (
                    <option key={agency.id} value={`filter_assigned_agency=${agency.id}`}>
                      {agency.name}
                    </option>
                  ))}
                </Form.Control>
              </div>
              <div className="mr-3">
                <Form.Control
                  as="select"
                  size="sm"
                  value={categoriaDiLavoroFilter}
                  onChange={(e) => {
                    setCurrentPage(1);
                    setCategoriaDiLavoroFilter(e.target.value);
                  }}
                  style={{ minWidth: '150px' }}
                >
                  <option value="">Categoria Lavoro</option>
                  <option value="filter_categoria_di_lavoro=pubblico">Pubblico</option>
                  <option value="filter_categoria_di_lavoro=statale">Statale</option>
                  <option value="filter_categoria_di_lavoro=privato">Privato</option>
                  <option value="filter_categoria_di_lavoro=pensionato">Pensionato</option>
                </Form.Control>
              </div>
              <div className="mr-3">
                <Form.Control
                  as="select"
                  size="sm"
                  value={hasMaturingTrattenutaFilter}
                  onChange={(e) => {
                    setCurrentPage(1);
                    setHasMaturingTrattenutaFilter(e.target.value);
                  }}
                  style={{ minWidth: '150px' }}
                >
                  <option value="">Contattare per rinnovo</option>
                  <option value="filter_has_maturing_trattenuta=true">Sì</option>
                  <option value="filter_has_maturing_trattenuta=false">No</option>
                </Form.Control>
              </div>
              <div className="mr-3" style={{ maxWidth: '300px' }}>
                <Form.Control
                  as="select"
                  size="sm"
                  value=""
                  onChange={(e) => {
                    const val = e.target.value;
                    if (!val) return;
                    setCurrentPage(1);
                    const current = opportunityStateFilter ? opportunityStateFilter.replace('filter_opportunity_state=', '').split(',') : [];
                    if (!current.includes(val)) {
                      const newValues = [...current, val];
                      setOpportunityStateFilter(`filter_opportunity_state=${newValues.join(',')}`);
                    }
                  }}
                  style={{ minWidth: '150px' }}
                >
                  <option value="">Aggiungi stato opportunità...</option>
                  {Object.entries(opportunityStatesMap).map(([key, label]) => (
                    <option key={key} value={key}>{label}</option>
                  ))}
                </Form.Control>
                {opportunityStateFilter && (
                  <div className="d-flex flex-wrap mt-1">
                    {opportunityStateFilter.replace('filter_opportunity_state=', '').split(',').map(val => (
                      <span key={val} className="badge badge-info mr-1 mb-1 d-flex align-items-center p-1">
                        {opportunityStatesMap[val] || val}
                        <span 
                          className="ml-1 font-weight-bold" 
                          style={{cursor: 'pointer'}}
                          onClick={() => {
                            const current = opportunityStateFilter.replace('filter_opportunity_state=', '').split(',');
                            const newValues = current.filter(v => v !== val);
                            setOpportunityStateFilter(newValues.length ? `filter_opportunity_state=${newValues.join(',')}` : '');
                            setCurrentPage(1);
                          }}
                        >
                          &times;
                        </span>
                      </span>
                    ))}
                  </div>
                )}
              </div>
              <div className="mr-3">
                <Form.Control
                  as="select"
                  size="sm"
                  value={createdByFilter}
                  onChange={(e) => {
                    setCurrentPage(1);
                    setCreatedByFilter(e.target.value);
                  }}
                  style={{ minWidth: '180px' }}
                >
                  <option value="">Creato da</option>
                  {users.map(user => (
                    <option key={user.email} value={`filter_created_by=${user.email}`}>
                      {user.name} {user.surname}
                    </option>
                  ))}
                </Form.Control>
              </div>
              <div className="mr-3 d-flex align-items-center">
                <Form.Label className="mb-0 mr-2" style={{ whiteSpace: 'nowrap' }}>Data creazione:</Form.Label>
                <Form.Control
                  type="date"
                  size="sm"
                  value={createdAtFrom}
                  onChange={(e) => {
                    setCurrentPage(1);
                    setCreatedAtFrom(e.target.value);
                  }}
                  placeholder="Da"
                  style={{ minWidth: '150px' }}
                />
              </div>
              <div className="mr-3 d-flex align-items-center">
                <Form.Label className="mb-0 mr-2">a</Form.Label>
                <Form.Control
                  type="date"
                  size="sm"
                  value={createdAtTo}
                  onChange={(e) => {
                    setCurrentPage(1);
                    setCreatedAtTo(e.target.value);
                  }}
                  placeholder="A"
                  style={{ minWidth: '150px' }}
                />
              </div>
              {(createdAtFrom || createdAtTo) && (
                <Button
                  variant="outline-secondary"
                  size="sm"
                  onClick={() => {
                    setCreatedAtFrom("");
                    setCreatedAtTo("");
                    setCurrentPage(1);
                  }}
                >
                  Cancella date
                </Button>
              )}
              {/* Data per richiamare filters */}
              <div className="mr-3 d-flex align-items-center">
                <Form.Label className="mb-0 mr-2" style={{ whiteSpace: 'nowrap' }}>Data richiamo:</Form.Label>
                <Form.Control
                  type="date"
                  size="sm"
                  value={dataPerRichiamareFrom}
                  onChange={(e) => {
                    setCurrentPage(1);
                    setDataPerRichiamareFrom(e.target.value);
                  }}
                  placeholder="Da"
                  style={{ minWidth: '150px' }}
                />
              </div>
              <div className="mr-3 d-flex align-items-center">
                <Form.Label className="mb-0 mr-2">a</Form.Label>
                <Form.Control
                  type="date"
                  size="sm"
                  value={dataPerRichiamareTo}
                  onChange={(e) => {
                    setCurrentPage(1);
                    setDataPerRichiamareTo(e.target.value);
                  }}
                  placeholder="A"
                  style={{ minWidth: '150px' }}
                />
              </div>
              {(dataPerRichiamareFrom || dataPerRichiamareTo) && (
                <Button
                  variant="outline-secondary"
                  size="sm"
                  onClick={() => {
                    setDataPerRichiamareFrom("");
                    setDataPerRichiamareTo("");
                    setCurrentPage(1);
                  }}
                >
                  Cancella date richiamo
                </Button>
              )}
            </div>

            <Row>
              <Col lg="12">
                <Card className="card-block card-stretch">
                  <Card.Body className="p-0">
                    <div className="table-responsive">
                      <table className="table data-table mb-0">
                        <thead className="table-color-heading">
                          <tr className="text-light">
                            {(config.is_admin || config.is_agency_boss) && (
                              <th scope="col" style={{ width: "5%" }}>
                                <Form.Check
                                  type="checkbox"
                                  checked={selectedContacts.length === contacts.length && contacts.length > 0}
                                  onChange={(e) => handleSelectAll(e.target.checked)}
                                />
                              </th>
                            )}
                            <th scope="col" style={{ width: "20%" }}>
                              <label className="text-muted m-0">Nome</label>
                              <SortToggle field="name" setSort={setSort} fetchList={fetchList} setCurrentPage={setCurrentPage} id={1}></SortToggle>
                            </th>
                            <th scope="col" style={{ width: "20%" }}>
                              <label className="text-muted m-0">Cognome</label>
                              <SortToggle field="surname" setSort={setSort} fetchList={fetchList} setCurrentPage={setCurrentPage} id={2}></SortToggle>
                            </th>
                            <th scope="col" style={{ width: "20%" }}>
                              <label className="text-muted m-0">Email</label>
                            </th>
                            <th scope="col" style={{ width: "20%" }}>
                              <label className="text-muted m-0">Telefone</label>
                            </th>
                            <th scope="col" style={{ width: "12%" }}>
                              <label className="text-muted m-0">CF</label>
                            </th>
                            <th scope="col" style={{ width: "10%" }}>
                              <label className="text-muted m-0">Stato</label>
                            </th>
                            <th scope="col" style={{ width: "10%" }}>
                              <label className="text-muted m-0">Stato Contatto</label>
                            </th>
                            <th scope="col" style={{ width: "10%" }}>
                              <label className="text-muted m-0">Categoria Lavoro</label>
                            </th>
                            <th scope="col" style={{ width: "10%" }}>
                              <label className="text-muted m-0">Cont. Rinnovo</label>
                            </th>
                            <th scope="col" style={{ width: "10%" }}>
                              <label className="text-muted m-0">Creato il</label>
                            </th>
                            <th scope="col" style={{ width: "10%" }}>
                              <label className="text-muted m-0">Creato da</label>
                            </th>
                            <th scope="col" style={{ width: "10%" }}>
                              <label className="text-muted m-0">Opportunità</label>
                            </th>
                            <th scope="col" style={{ width: "12%" }}>
                              <label className="text-muted m-0">Assegnato a</label>
                            </th>
                            <th scope="col" style={{ width: "12%" }}>
                              <label className="text-muted m-0">Agenzia</label>
                            </th>
                            <th scope="col" style={{ width: "20%" }}></th>
                          </tr>
                        </thead>
                        <tbody>
                          {loading ? (
                            <tr style={{ height: "100px", paddingTop: "10px" }}>
                              <td>
                                <p className="loader"></p>
                              </td>
                            </tr>
                          ) : (
                            <>
                              {(contacts||[]).map((c, index)=> (
                                <tr key={index} className="white-space-no-wrap">
                              {(config.is_admin || config.is_agency_boss) && (
                                <td>
                                  <Form.Check
                                    type="checkbox"
                                    checked={selectedContacts.includes(c.id)}
                                    onChange={(e) => handleContactSelect(c.id, e.target.checked)}
                                  />
                                </td>
                              )}
                              <td>{c.name}</td>
                              <td>{c.surname}</td>
                              <td>{c.email}</td>
                              <td>{c.telefone}</td>
                              <td>{c.codice_fiscale}</td>
                              <td>
                                <h6 className={`${c.is_suspended ? "bg-warning" : "bg-success"} rounded rounded-pill px-2 py-1`}>
                                  {c.is_suspended ? "Sospeso" : "Attivo"}
                                </h6>
                              </td>
                              <td>
                                <div>
                                  <span className={`badge ${
                                    c.contact_status === 'Contatto Attivo' ? 'bg-success' :
                                    c.contact_status === 'Contatto Interessato' ? 'bg-primary' :
                                    c.contact_status === 'Contatto Non Interessato' ? 'bg-secondary' :
                                    c.contact_status === 'Richiamo Concordato' ? 'bg-warning' :
                                    c.contact_status === 'Non Risponde' ? 'bg-danger' :
                                    'bg-info'
                                  }`}>
                                    {c.contact_status || 'N/A'}
                                  </span>
                                  {c.contact_status === 'Richiamo Concordato' && c.data_per_richiamare && (
                                    <div>
                                      <small className="text-muted">
                                        {(() => {
                                          try {
                                            return new Date(c.data_per_richiamare).toLocaleDateString('it-IT')
                                          } catch (e) {
                                            return c.data_per_richiamare
                                          }
                                        })()}
                                      </small>
                                    </div>
                                  )}
                                </div>
                              </td>
                              <td>
                                <span className="text-capitalize">{c.categoria_di_lavoro || '-'}</span>
                              </td>
                              <td>
                                {c.has_maturing_trattenuta ? (
                                  <span className="badge bg-danger">Sì</span>
                                ) : (
                                  <span className="text-muted">No</span>
                                )}
                              </td>
                              <td>{c.created_at}</td>
                              <td>{c.created_by?.name}</td>
                              <td style={{ minWidth: "150px" }}>
                                {c.opportunities && c.opportunities.length > 0 ? (
                                  c.opportunities.map((opportunity) => (
                                    <span key={opportunity.id} className="badge bg-warning mx-1">{opportunity.state?.name || opportunity.state}</span>
                                  ))
                                ) : (
                                  <span className="badge bg-info">N/A</span>
                                )}
                              </td>
                              <td>
                                <span className="text-muted">
                                  {c.assigned_user ? `${c.assigned_user.name} ${c.assigned_user.surname}` : 'Non assegnato'}
                                </span>
                              </td>
                              <td>
                                <span className="text-muted">
                                  {c.assigned_agency ? c.assigned_agency.name : 'Non assegnata'}
                                </span>
                              </td>
                              <td>
                                <div className="d-flex justify-content-end align-items-center">
                                  {config.is_admin ? (
                                    <OverlayTrigger
                                      placement="top"
                                      overlay={<Tooltip>Toggle Status</Tooltip>}
                                    >
                                      <BootstrapSwitchButton
                                        checked={!c.is_suspended}
                                        size="sm"
                                        onChange={async (e) => {
                                          const resp = await service.toggleSuspendProduct(c.id);
                                          if (resp !== null) {
                                            contacts[index].is_suspended = !contacts[index].is_suspended;
                                            setContacts([...contacts]);
                                          }
                                        }}
                                      />
                                    </OverlayTrigger>
                                  ) : null}
                                  
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>History</Tooltip>}
                                  >
                                    <Link to={`/contact-service-history/${c.id}`} className="mr-2">
                                       <svg xmlns="http://www.w3.org/2000/svg" className="text-secondary" width="20" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                                        </svg>
                                    </Link>
                                  </OverlayTrigger>
                                  
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip>
                                        {config.is_admin ? "Edit" : "View"}
                                      </Tooltip>
                                    }
                                  >
                                    <Link to={{ pathname: `/contact-view/${c.id}`, state: {
                                      "filter" : filter, 
                                      "sort" : sort, 
                                      "search" : search, 
                                      "page" : page,
                                      "contactStatusFilter": contactStatusFilter,
                                      "assignedUserFilter": assignedUserFilter,
                                      "assignedAgencyFilter": assignedAgencyFilter,
                                      "categoriaDiLavoroFilter": categoriaDiLavoroFilter,
                                      "createdByFilter": createdByFilter,
                                      "createdAtFrom": createdAtFrom,
                                      "createdAtTo": createdAtTo,
                                      "dataPerRichiamareFrom": dataPerRichiamareFrom,
                                      "dataPerRichiamareTo": dataPerRichiamareTo,
                                      "opportunityStateFilter": opportunityStateFilter,
                                      "hasMaturingTrattenutaFilter": hasMaturingTrattenutaFilter
                                    } }}>
                                      {config.is_admin ? (
                                        <>
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            className="text-secondary mx-4"
                                            width="20"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            stroke="currentColor"
                                          >
                                            <path
                                              strokeLinecap="round"
                                              strokeLinejoin="round"
                                              strokeWidth="2"
                                              d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"
                                            />
                                          </svg>
                                        </>
                                      ) : (
                                        <>
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            className="text-secondary mx-4"
                                            width="20"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            stroke="currentColor"
                                          >
                                            <path d="M3 2.5A1.5 1.5 0 0 1 4.5 1h1A1.5 1.5 0 0 1 7 2.5V5h2V2.5A1.5 1.5 0 0 1 10.5 1h1A1.5 1.5 0 0 1 13 2.5v2.382a.5.5 0 0 0 .276.447l.895.447A1.5 1.5 0 0 1 15 7.118V14.5a1.5 1.5 0 0 1-1.5 1.5h-3A1.5 1.5 0 0 1 9 14.5v-3a.5.5 0 0 1 .146-.354l.854-.853V9.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v.793l.854.853A.5.5 0 0 1 7 11.5v3A1.5 1.5 0 0 1 5.5 16h-3A1.5 1.5 0 0 1 1 14.5V7.118a1.5 1.5 0 0 1 .83-1.342l.894-.447A.5.5 0 0 0 3 4.882V2.5zM4.5 2a.5.5 0 0 0-.5.5V3h2v-.5a.5.5 0 0 0-.5-.5h-1zM6 4H4v.882a1.5 1.5 0 0 1-.83 1.342l-.894.447A.5.5 0 0 0 2 7.118V13h4v-1.293l-.854-.853A.5.5 0 0 1 5 10.5v-1A1.5 1.5 0 0 1 6.5 8h3A1.5 1.5 0 0 1 11 9.5v1a.5.5 0 0 1-.146.354l-.854.853V13h4V7.118a.5.5 0 0 0-.276-.447l-.895-.447A.5.5 0 0 1 12 4.882V4h-2v1.5a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5V4zm4-1h2v-.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5V3zm4 11h-4v.5a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5V14zm-8 0H2v.5a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5V14z" />
                                          </svg>
                                        </>
                                      )}
                                    </Link>
                                  </OverlayTrigger>

                                  {(config.is_admin || config.is_agency_boss) && (
                                    <OverlayTrigger
                                      placement="top"
                                      overlay={<Tooltip>Assegna</Tooltip>}
                                    >
                                      <Button
                                        variant="outline-primary"
                                        size="sm"
                                        className="mx-2"
                                        onClick={() => {
                                          setCurrentContact(c);
                                          setShowIndividualAssignModal(true);
                                          setIndividualAssignmentType('');
                                          setIndividualSelectedUserId('');
                                          setIndividualSelectedAgencyId('');
                                        }}
                                      >
                                        Assegna
                                      </Button>
                                    </OverlayTrigger>
                                  )}

                                  {!config.is_admin ? (
                                    ""
                                  ) : (
                                    <>
                                      <OverlayTrigger
                                        placement="top"
                                        overlay={<Tooltip>Delete</Tooltip>}
                                      >
                                        <h6
                                          className="badge bg-danger"
                                          onClick={async () => {
                                            const resp = await service.deleteProduct(c.id);
                                            if (resp !== null) {
                                              await fetchList();
                                            }
                                          }}
                                        >
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="20"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            stroke="currentColor"
                                          >
                                            <path
                                              strokeLinecap="round"
                                              strokeLinejoin="round"
                                              strokeWidth="2"
                                              d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                                            />
                                          </svg>
                                        </h6>
                                      </OverlayTrigger>
                                    </>
                                  )}
                                </div>
                              </td>
                            </tr>
                          ))}
                            </>
                          )}
                        </tbody>
                      </table>
                    </div>
                    {paginationObject ? (
                      <PaginationComponent fetchList={fetchList} paginationObject={paginationObject} nPages={nPages} page={page} numberOfItem={numberOfItem} />
                    ) : null}
                  </Card.Body>
                </Card>
              </Col>
            </Row>

          </Col>
        </Row>
      </Container>

      {/* Bulk Assignment Modal */}
      <Modal show={showBulkAssignModal} onHide={() => setShowBulkAssignModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Assegna Contatti</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Seleziona l'utente o l'agenzia da assegnare a {selectedContacts.length} contatti:</p>
          
          {/* Assignment Type Selection - Only for Admin */}
          {config.is_admin && (
            <div className="mb-3">
              <Form.Label>Tipo di Assegnazione:</Form.Label>
              <Form.Control
                as="select"
                value={assignmentType}
                onChange={(e) => setAssignmentType(e.target.value)}
              >
                <option value="">Seleziona tipo...</option>
                <option value="user">Assegna a Utente</option>
                <option value="agency">Assegna a Agenzia</option>
              </Form.Control>
            </div>
          )}

          {/* User Assignment - Available for Agency Boss and Admin */}
          <div className="mb-3">
            <Form.Label>Assegna a Utente:</Form.Label>
            <Form.Control
              as="select"
              id="bulk-assign-user"
              value={selectedUserId}
              disabled={config.is_admin && assignmentType !== 'user'}
              onChange={(e) => setSelectedUserId(e.target.value)}
            >
              <option value="">Seleziona utente...</option>
              {users.map(user => (
                <option key={user.email} value={user.email}>
                  {user.name} {user.surname}
                </option>
              ))}
            </Form.Control>
            {config.is_agency_boss && !config.is_admin && (
              <small className="text-muted">
                Puoi assegnare solo agli utenti della tua agenzia
              </small>
            )}
            {config.is_admin && assignmentType !== 'user' && (
              <small className="text-muted">
                Seleziona "Assegna a Utente" per abilitare questa opzione
              </small>
            )}
            {selectedUserId && (
              <div className="mt-2">
                <Button 
                  variant="primary" 
                  size="sm"
                  onClick={() => handleBulkAssign(selectedUserId, null)}
                >
                  Assegna a {users.find(u => u.email == selectedUserId)?.name} {users.find(u => u.email == selectedUserId)?.surname}
                </Button>
              </div>
            )}
          </div>

          {/* Agency Assignment - Only available for Admin */}
          {config.is_admin && (
            <div className="mb-3">
              <Form.Label>Assegna a Agenzia:</Form.Label>
              <Form.Control
                as="select"
                id="bulk-assign-agency"
                value={selectedAgencyId}
                disabled={assignmentType !== 'agency'}
                onChange={(e) => setSelectedAgencyId(e.target.value)}
              >
                <option value="">Seleziona agenzia...</option>
                {agencies.map(agency => (
                  <option key={agency.id} value={agency.id}>
                    {agency.name}
                  </option>
                ))}
              </Form.Control>
              {assignmentType !== 'agency' && (
                <small className="text-muted">
                  Seleziona "Assegna a Agenzia" per abilitare questa opzione
                </small>
              )}
              {selectedAgencyId && (
                <div className="mt-2">
                  <Button 
                    variant="primary" 
                    size="sm"
                    onClick={() => handleBulkAssign(null, selectedAgencyId)}
                  >
                    Assegna a {agencies.find(a => a.id == selectedAgencyId)?.name}
                  </Button>
                </div>
              )}
            </div>
          )}

          <div className="mb-3">
            <Button 
              variant="outline-danger" 
              size="sm"
              onClick={() => handleBulkAssign(null, null)}
            >
              Rimuovi tutte le assegnazioni
            </Button>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => {
            setShowBulkAssignModal(false)
            setAssignmentType('')
            setSelectedUserId('')
            setSelectedAgencyId('')
          }}>
            Annulla
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Individual Assignment Modal */}
      <Modal show={showIndividualAssignModal} onHide={() => setShowIndividualAssignModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Assegna Contatto</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {currentContact && (
            <p>Assegna il contatto <strong>{currentContact.name} {currentContact.surname}</strong>:</p>
          )}
          
          {/* Assignment Type Selection - Only for Admin */}
          {config.is_admin && (
            <div className="mb-3">
              <Form.Label>Tipo di Assegnazione:</Form.Label>
              <Form.Control
                as="select"
                value={individualAssignmentType}
                onChange={(e) => setIndividualAssignmentType(e.target.value)}
              >
                <option value="">Seleziona tipo...</option>
                <option value="user">Assegna a Utente</option>
                <option value="agency">Assegna a Agenzia</option>
              </Form.Control>
            </div>
          )}

          {/* User Assignment - Available for Agency Boss and Admin */}
          <div className="mb-3">
            <Form.Label>Assegna a Utente:</Form.Label>
            <Form.Control
              as="select"
              id="individual-assign-user"
              value={individualSelectedUserId}
              disabled={config.is_admin && individualAssignmentType !== 'user'}
              onChange={(e) => setIndividualSelectedUserId(e.target.value)}
            >
              <option value="">Seleziona utente...</option>
              {users.map(user => (
                <option key={user.email} value={user.email}>
                  {user.name} {user.surname}
                </option>
              ))}
            </Form.Control>
            {config.is_agency_boss && !config.is_admin && (
              <small className="text-muted">
                Puoi assegnare solo agli utenti della tua agenzia
              </small>
            )}
            {config.is_admin && individualAssignmentType !== 'user' && (
              <small className="text-muted">
                Seleziona "Assegna a Utente" per abilitare questa opzione
              </small>
            )}
            {individualSelectedUserId && (
              <div className="mt-2">
                <Button 
                  variant="primary" 
                  size="sm"
                  onClick={() => handleIndividualAssign(currentContact.id, individualSelectedUserId, null)}
                >
                  Assegna a {users.find(u => u.email == individualSelectedUserId)?.name} {users.find(u => u.email == individualSelectedUserId)?.surname}
                </Button>
              </div>
            )}
          </div>

          {/* Agency Assignment - Only available for Admin */}
          {config.is_admin && (
            <div className="mb-3">
              <Form.Label>Assegna a Agenzia:</Form.Label>
              <Form.Control
                as="select"
                id="individual-assign-agency"
                value={individualSelectedAgencyId}
                disabled={individualAssignmentType !== 'agency'}
                onChange={(e) => setIndividualSelectedAgencyId(e.target.value)}
              >
                <option value="">Seleziona agenzia...</option>
                {agencies.map(agency => (
                  <option key={agency.id} value={agency.id}>
                    {agency.name}
                  </option>
                ))}
              </Form.Control>
              {individualAssignmentType !== 'agency' && (
                <small className="text-muted">
                  Seleziona "Assegna a Agenzia" per abilitare questa opzione
                </small>
              )}
              {individualSelectedAgencyId && (
                <div className="mt-2">
                  <Button 
                    variant="primary" 
                    size="sm"
                    onClick={() => handleIndividualAssign(currentContact.id, null, individualSelectedAgencyId)}
                  >
                    Assegna a {agencies.find(a => a.id == individualSelectedAgencyId)?.name}
                  </Button>
                </div>
              )}
            </div>
          )}

          <div className="mb-3">
            <Button 
              variant="outline-danger" 
              size="sm"
              onClick={() => handleIndividualAssign(currentContact.id, null, null)}
            >
              Rimuovi assegnazione
            </Button>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => {
            setShowIndividualAssignModal(false)
            setCurrentContact(null)
            setIndividualAssignmentType('')
            setIndividualSelectedUserId('')
            setIndividualSelectedAgencyId('')
          }}>
            Annulla
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default Contact


